import template from './insurance-detail.html';
import controller from './insurance-detail.controller';

let insuranceDetailComponent = {
  bindings: {},
  template,
  controller
};

export default insuranceDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-detail.component.js